import type { FunctionComponent, PropsWithChildren } from 'react';
import { Fragment } from 'react';
import { useDocumentTitle } from 'usehooks-ts';

export const PageWithTitle: FunctionComponent<PropsWithChildren<{ readonly title: string }>> = ({
    children,
    title,
}) => {
    useDocumentTitle(title);

    return <Fragment>{children}</Fragment>;
};
